import EA from 'helpers/init';
import Swiper from 'swiper/swiper-bundle.esm.js';

export default EA.Methods.sliderHoliday = ($this) => {

    const initializeSwiperBanners = () => {
        const slider = $this.querySelector('.swiper');
        const pagination = $this.querySelector('.swiper-pagination');
        const bannerSlides = $this.querySelectorAll('.swiper-slide.banner-zone');

        bannerSlides.forEach((slide) => {
            if (slide.classList.contains('slide-banner-deactivated')) {
                slide.remove();
            }
        });

        const swipeInit = new Swiper(slider, {
            speed: 600,
            slidesPerView: 1,
            touchRatio: 1,
            loop: false,
            watchSlidesProgress: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
        });

        swipeInit.update();
    };

    const initializeSwiperCasual = () => {
        const slider = $this.querySelector('.swiper');
        const pagination = $this.querySelector('.swiper-pagination');
        const bannerZone = $this.querySelectorAll('.banner-zone');

        bannerZone.forEach((zone) => {
            zone.remove();
        });

        const swipeInit = new Swiper(slider, {
            speed: 600,
            slidesPerView: 1,
            touchRatio: 1,
            loop: false,
            watchSlidesProgress: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
        });

        swipeInit.update();
    };

    // Check if ad blocker is enabled by checking for the ad-blocker-detected class added by handleScriptError function in footer script.
    const sliderAdBlock = $this.querySelector('.swiper.ad-blocker-detected');

    if (sliderAdBlock) {
        initializeSwiperCasual();
    } else {
        document.addEventListener('mutationsHandled', initializeSwiperBanners);
    };
};